import { render, staticRenderFns } from "./MemberEditTabAddress.vue?vue&type=template&id=62554805"
import script from "./MemberEditTabAddress.vue?vue&type=script&lang=js"
export * from "./MemberEditTabAddress.vue?vue&type=script&lang=js"
import style0 from "./MemberEditTabAddress.vue?vue&type=style&index=0&id=62554805&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports